import { render, staticRenderFns } from "./skillLock.vue?vue&type=template&id=2256c9cf&scoped=true&"
import script from "./skillLock.vue?vue&type=script&lang=js&"
export * from "./skillLock.vue?vue&type=script&lang=js&"
import style0 from "./skillLock.vue?vue&type=style&index=0&id=2256c9cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256c9cf",
  null
  
)

export default component.exports